export const DataDiplomas = [
  {
    'id': 1,
    'type': 'Careers',
    'description': [
      {
        'id': 1,
        'date': '2019/11/05',
        'name': 'Carrera de Desarrollo con Wordpress',
        'url': 'https://live.staticflickr.com/65535/50474012157_ed774c5efc_h.jpg'
      },
      {
        'id': 2,
        'date': '2019/10/12',
        'name': 'Carrera de Email Marketing',
        'url': 'https://live.staticflickr.com/65535/50473155333_aa303af6aa_h.jpg'
      },
      {
        'id': 3,
        'date': '2019/10/01',
        'name': 'Carrera de Outbound Marketing',
        'url': 'https://live.staticflickr.com/65535/50473858046_f73a8f37c7_h.jpg'
      }
    ]
  },
  {
    'id': 2,
    'type': 'English',
    'description': [
      {
        'id': 1,
        'date': '2017/10/17',
        'name': 'English Dot Works Beginner',
        'url': 'https://live.staticflickr.com/65535/50511364981_900840b11b_b.jpg'
      },
      {
        'id': 2,
        'date': '2009/08/21',
        'name': 'English Discoveries Basic I',
        'url': 'https://live.staticflickr.com/65535/50511528377_aa75d0520e_b.jpg'
      },
      {
        'id': 3,
        'date': '2009/10/23',
        'name': 'English Discoveries Basic II',
        'url': 'https://live.staticflickr.com/65535/50511364946_8904c465e7_b.jpg'
      },
      {
        'id': 4,
        'date': '2019/12/29',
        'name': 'Como Aprender Inglés por Cuenta Propia Usando Internet',
        'url': 'https://live.staticflickr.com/65535/50511623262_89ca329f3d_b.jpg'
      },
      {
        'id': 5,
        'date': '2019/01/08',
        'name': 'Basic English Course Fundamentals',
        'url': 'https://live.staticflickr.com/65535/50512082297_fe88d51c82_b.jpg'
      },
      {
        'id': 6,
        'date': '2020/09/24',
        'name': 'English Course For Beginners',
        'url': 'https://live.staticflickr.com/65535/50511203993_8f7eea7e33_b.jpg'
      },
      {
        'id': 7,
        'date': '2020/09/22',
        'name': 'Strategies to Learn English Online',
        'url': 'https://live.staticflickr.com/65535/50511921351_598be5a1dd_b.jpg'
      },
      {
        'id': 8,
        'date': '2019/03/16',
        'name': 'Inglés Básico Conversación',
        'url': 'https://live.staticflickr.com/65535/50511203953_1a79559305_b.jpg'
      },
      {
        'id': 9,
        'date': '2019/04/21',
        'name': 'Inglés Básico Gramática',
        'url': 'https://live.staticflickr.com/65535/50511921311_f3e727e354_b.jpg'
      },
      {
        'id': 10,
        'date': '2019/01/08',
        'name': 'Inglés Básico',
        'url': 'https://live.staticflickr.com/65535/50511921281_5f4faae996_b.jpg'
      },
      {
        'id': 11,
        'date': '2020/09/22',
        'name': 'Strategies to Learn English Online',
        'url': 'https://live.staticflickr.com/65535/50511203888_392782f8e4_b.jpg'
      }
    ]
  },
  {
    'id': 3,
    'type': 'Development and Engineering',
    'description': [
      {
        'id': 1,
        'date': '2020/09/29',
        'name': 'Programación Básica',
        'url': 'https://live.staticflickr.com/65535/50481814852_fe16f82a5c_h.jpg'
      },
      {
        'id': 2,
        'date': '2016/11/01',
        'name': 'Navegación Segura',
        'url': 'https://live.staticflickr.com/65535/50483210972_a030da9c6c_b.jpg'
      },
      {
        'id': 3,
        'date': '2017/05/15',
        'name': 'Desarrollo de Apps Móviles',
        'url': 'https://live.staticflickr.com/65535/50510459883_3c8d6ed841_k.jpg'
      },
      {
        'id': 4,
        'date': '2017/03/12',
        'name': 'Desarrollo Web',
        'url': 'https://live.staticflickr.com/65535/50511174381_897ce2827d_k.jpg'
      },
      {
        'id': 5,
        'date': '2017/07/10',
        'name': 'Corel Draw - Textos y Organización de Objetos',
        'url': 'https://live.staticflickr.com/65535/50511489577_c43ef5dbf0_b.jpg'
      },
      {
        'id': 6,
        'date': '2013/10/23',
        'name': 'Desarrollo de Aplicaciones con Interfaz Gráfica, Manejo de Eventos, Clases, y Objetos Java',
        'url': 'https://live.staticflickr.com/65535/50511326351_0921614e09_b.jpg'
      },
      {
        'id': 7,
        'date': '2012/08/22',
        'name': 'Diseño de Base de Datos en SQL',
        'url': 'https://live.staticflickr.com/65535/50511326326_e4470dedde_b.jpg'
      },
      {
        'id': 8,
        'date': '2009/11/26',
        'name': 'Fundamentación de Ensamble y Mantenimiento de Computadores para Procesos de Soporte Técnico',
        'url': 'https://live.staticflickr.com/65535/50511489547_77d17f460e_b.jpg'
      },
      {
        'id': 9,
        'date': '2012/08/26',
        'name': 'Linux Sistema Operativo Comandos y Utilidad',
        'url': 'https://live.staticflickr.com/65535/50511489517_990392001b_b.jpg'
      },
      {
        'id': 10,
        'date': '2013/09/18',
        'name': 'Programación de Dispositivos Móviles',
        'url': 'https://live.staticflickr.com/65535/50511489472_c4c85e4dab_b.jpg'
      },
      {
        'id': 11,
        'date': '2012/09/20',
        'name': 'Redes y Seguridad',
        'url': 'https://live.staticflickr.com/65535/50511489437_7f37b32df9_b.jpg'
      },
      {
        'id': 12,
        'date': '2013/09/17',
        'name': 'Variables y Estructuras de Control en la Programación Orientada a Objetos Java',
        'url': 'https://live.staticflickr.com/65535/50511326226_9c87df5fd5_b.jpg'
      },
      {
        'id': 13,
        'date': '2018/06/08',
        'name': 'HTML y CSS',
        'url': 'https://live.staticflickr.com/65535/50511387636_168e13f25c_b.jpg'
      },
      {
        'id': 14,
        'date': '2018/06/11',
        'name': 'Aprende HTML5 y CSS3 desde cero',
        'url': 'https://live.staticflickr.com/65535/50510741663_524471dbf2_b.jpg'
      },
      {
        'id': 15,
        'date': '2017/02/28',
        'name': 'Animación 3D Autodesk Maya',
        'url': 'https://live.staticflickr.com/65535/50511464061_5b796d0fac_b.jpg'
      },
      {
        'id': 16,
        'date': '2020/06/16',
        'name': 'React Js',
        'url': 'https://live.staticflickr.com/65535/50511597291_14f4584889_b.jpg'
      },
      {
        'id': 17,
        'date': '2020/06/16',
        'name': 'React Js',
        'url': 'https://live.staticflickr.com/65535/50510882603_04c5d6fedf_b.jpg'
      },
      {
        'id': 18,
        'date': '2019/09/16',
        'name': 'Redes de Internet',
        'url': 'https://live.staticflickr.com/65535/50510882573_b76c5b0b4d_b.jpg'
      },
      {
        'id': 19,
        'date': '2019/07/14',
        'name': 'Redux por Bedu',
        'url': 'https://live.staticflickr.com/65535/50511597246_ea5b6b8f99_b.jpg'
      },
      {
        'id': 20,
        'date': '2018/12/14',
        'name': 'Responsive Design',
        'url': 'https://live.staticflickr.com/65535/50510882553_19867ff14b_b.jpg'
      },
      {
        'id': 21,
        'date': '2020/07/07',
        'name': 'Router Para Single Page App con JavaScript',
        'url': 'https://live.staticflickr.com/65535/50511757012_7e684a9fba_b.jpg'
      },
      {
        'id': 22,
        'date': '2020/06/22',
        'name': 'SASS',
        'url': 'https://live.staticflickr.com/65535/50511597181_74ee8c038d_b.jpg'
      },
      {
        'id': 23,
        'date': '2020/04/12',
        'name': 'Single Page application con JavaScript Vanilla',
        'url': 'https://live.staticflickr.com/65535/50511597166_ea9a01f92f_b.jpg'
      },
      {
        'id': 24,
        'date': '2020/06/19',
        'name': 'Sistemas de Diseño para Desarrolladores',
        'url': 'https://live.staticflickr.com/65535/50511756942_a07bf72bf4_b.jpg'
      },
      {
        'id': 25,
        'date': '2019/01/04',
        'name': 'Stylus',
        'url': 'https://live.staticflickr.com/65535/50510882438_f5df095423_b.jpg'
      },
      {
        'id': 26,
        'date': '2020/09/22',
        'name': 'Unit Testing con Jest en React',
        'url': 'https://live.staticflickr.com/65535/50510882408_4919a65bb4_b.jpg'
      },
      {
        'id': 27,
        'date': '2020/06/30',
        'name': 'Accesibilidad Web',
        'url': 'https://live.staticflickr.com/65535/50511756892_6dc3729203_b.jpg'
      },
      {
        'id': 28,
        'date': '2020/05/15',
        'name': 'Introducción a los Algoritmos de Ordenamiento',
        'url': 'https://live.staticflickr.com/65535/50511756872_160372fb75_b.jpg'
      },
      {
        'id': 29,
        'date': '2020/05/15',
        'name': 'Algoritmos',
        'url': 'https://live.staticflickr.com/65535/50510882338_008df08f66_b.jpg'
      },
      {
        'id': 30,
        'date': '2018/12/22',
        'name': 'Animaciones para la Web',
        'url': 'https://live.staticflickr.com/65535/50511597051_ec088777e4_b.jpg'
      },
      {
        'id': 31,
        'date': '2020/07/12',
        'name': 'Api Rest',
        'url': 'https://live.staticflickr.com/65535/50511597011_0e8ca21384_b.jpg'
      },
      {
        'id': 32,
        'date': '2020/06/11',
        'name': 'Asincronismo con JavaScript',
        'url': 'https://live.staticflickr.com/65535/50511596991_c47f7baa2c_b.jpg'
      },
      {
        'id': 33,
        'date': '2019/09/21',
        'name': 'Bases Técnicas de Android',
        'url': 'https://live.staticflickr.com/65535/50511756777_ce0332e8a3_b.jpg'
      },
      {
        'id': 34,
        'date': '2019/11/03',
        'name': 'Bootstrap',
        'url': 'https://live.staticflickr.com/65535/50511596931_2503ebe9cd_b.jpg'
      },
      {
        'id': 35,
        'date': '2019/09/29',
        'name': 'Circuitos Electrónicos',
        'url': 'https://live.staticflickr.com/65535/50511596896_170a38809c_b.jpg'
      },
      {
        'id': 36,
        'date': '2020/07/08',
        'name': 'Closures y Scope en JavaScript',
        'url': 'https://live.staticflickr.com/65535/50510882238_4cb4d2ae4f_b.jpg'
      },
      {
        'id': 37,
        'date': '2019/05/03',
        'name': 'Temas y Plugins en WordPress',
        'url': 'https://live.staticflickr.com/65535/50511596861_7e76529c35_b.jpg'
      },
      {
        'id': 38,
        'date': '2019/04/14',
        'name': 'Creación y Optimización de Sitios Web con WordPress',
        'url': 'https://live.staticflickr.com/65535/50511756677_76770bc667_b.jpg'
      },
      {
        'id': 39,
        'date': '2018/12/28',
        'name': 'CSS Grid Layout',
        'url': 'https://live.staticflickr.com/65535/50511756662_806f6c85d6_b.jpg'
      },
      {
        'id': 40,
        'date': '2020/08/12',
        'name': 'Deploy con Now Sh',
        'url': 'https://live.staticflickr.com/65535/50510882158_6f2cfe1bf0_b.jpg'
      },
      {
        'id': 41,
        'date': '2018/11/21',
        'name': 'Desarrollo Web Online',
        'url': 'https://live.staticflickr.com/65535/50511596786_2fb6dec28d_b.jpg'
      },
      {
        'id': 42,
        'date': '2020/08/20',
        'name': 'Diseño de Interfaces',
        'url': 'https://live.staticflickr.com/65535/50510882133_1da723b408_b.jpg'
      },
      {
        'id': 43,
        'date': '2020/07/01',
        'name': 'Diseño de Prototipos',
        'url': 'https://live.staticflickr.com/65535/50511596756_ac1b34e38a_b.jpg'
      },
      {
        'id': 44,
        'date': '2019/10/12',
        'name': 'Diseño de HTML y CSS para Emails',
        'url': 'https://live.staticflickr.com/65535/50510882113_5df5135905_b.jpg'
      },
      {
        'id': 45,
        'date': '2020/06/12',
        'name': 'Ecmascript 6',
        'url': 'https://live.staticflickr.com/65535/50511596736_a1bdb2c9ce_b.jpg'
      },
      {
        'id': 46,
        'date': '2020/05/20',
        'name': 'Expresiones Regulares',
        'url': 'https://live.staticflickr.com/65535/50510882088_9ebf03fd6a_b.jpg'
      },
      {
        'id': 47,
        'date': '2020/04/18',
        'name': 'Firebase para Web',
        'url': 'https://live.staticflickr.com/65535/50511756552_ef7fa4e4ac_b.jpg'
      },
      {
        'id': 48,
        'date': '2020/04/12',
        'name': 'Frontend Developer',
        'url': 'https://live.staticflickr.com/65535/50510882053_b379d0b712_b.jpg'
      },
      {
        'id': 49,
        'date': '2020/05/27',
        'name': 'Arquitectura de Software',
        'url': 'https://live.staticflickr.com/65535/50511596606_83686654d4_b.jpg'
      },
      {
        'id': 50,
        'date': '2019/10/02',
        'name': 'Fundamentos de Bases de Datos',
        'url': 'https://live.staticflickr.com/65535/50511756492_7f07e2071b_b.jpg'
      },
      {
        'id': 51,
        'date': '2019/09/18',
        'name': 'Electricidad y Electrónica',
        'url': 'https://live.staticflickr.com/65535/50511756487_012a72f303_b.jpg'
      },
      {
        'id': 52,
        'date': '2018/12/04',
        'name': 'Fundamentos de Ingeniería de Software',
        'url': 'https://live.staticflickr.com/65535/50511596551_4e3480522d_b.jpg'
      },
      {
        'id': 53,
        'date': '2019/10/25',
        'name': 'Fundamentos de JavaScript',
        'url': 'https://live.staticflickr.com/65535/50511596521_c3937852b3_b.jpg'
      },
      {
        'id': 54,
        'date': '2020/09/30',
        'name': 'Fundamentos de Node Js',
        'url': 'https://live.staticflickr.com/65535/50510881998_05e7c39417_b.jpg'
      },
      {
        'id': 55,
        'date': '2020/05/29',
        'name': 'Fundamentos de Pruebas de Software',
        'url': 'https://live.staticflickr.com/65535/50510881978_bbca5d23a6_b.jpg'
      },
      {
        'id': 56,
        'date': '2020/05/18',
        'name': 'Gestión de Dependencias y Paquetes con NPM',
        'url': 'https://live.staticflickr.com/65535/50510881963_cd166605b5_b.jpg'
      },
      {
        'id': 57,
        'date': '2020/07/25',
        'name': 'Graphql',
        'url': 'https://live.staticflickr.com/65535/50511596456_d90ced3986_b.jpg'
      },
      {
        'id': 58,
        'date': '2020/05/29',
        'name': 'HTML y CSS',
        'url': 'https://live.staticflickr.com/65535/50511756372_c329af1c2d_b.jpg'
      },
      {
        'id': 59,
        'date': '2020/07/09',
        'name': 'Integración de Backend y Frontend',
        'url': 'https://live.staticflickr.com/65535/50511596446_88ca3ab29a_b.jpg'
      },
      {
        'id': 60,
        'date': '2018/12/06',
        'name': 'Terminal y Línea de Comandos',
        'url': 'https://live.staticflickr.com/65535/50510881893_c4a5087ed8_b.jpg'
      },
      {
        'id': 61,
        'date': '2020/05/19',
        'name': 'Terminal y Línea de Comandos',
        'url': 'https://live.staticflickr.com/65535/50510881868_633c39737f_b.jpg'
      },
      {
        'id': 62,
        'date': '2019/11/05',
        'name': 'PHP',
        'url': 'https://live.staticflickr.com/65535/50510881838_1ae69bfa35_b.jpg'
      },
      {
        'id': 63,
        'date': '2020/06/05',
        'name': 'JavaScript Engine V8 y el Navegador',
        'url': 'https://live.staticflickr.com/65535/50511596371_9c00723eb8_b.jpg'
      },
      {
        'id': 64,
        'date': '2020/04/21',
        'name': 'JavaScript',
        'url': 'https://live.staticflickr.com/65535/50510881813_22bf4f7675_b.jpg'
      },
      {
        'id': 65,
        'date': '2019/04/27',
        'name': 'Jenkins',
        'url': 'https://live.staticflickr.com/65535/50510881793_0bf8006d4c_b.jpg'
      },
      {
        'id': 66,
        'date': '2020/04/04',
        'name': 'Kotlin',
        'url': 'https://live.staticflickr.com/65535/50510881778_53877669dc_b.jpg'
      },
      {
        'id': 67,
        'date': '2020/06/12',
        'name': 'Maquetación en CSS',
        'url': 'https://live.staticflickr.com/65535/50511596286_b5806ccae7_b.jpg'
      },
      {
        'id': 68,
        'date': '2020/07/01',
        'name': 'Materialize',
        'url': 'https://live.staticflickr.com/65535/50511596276_54238c9773_b.jpg'
      },
      {
        'id': 69,
        'date': '2020/09/29',
        'name': 'Mongo DB',
        'url': 'https://live.staticflickr.com/65535/50511596246_c8876fb7c5_b.jpg'
      },
      {
        'id': 70,
        'date': '2020/04/12',
        'name': 'Pagos Online con Paypal',
        'url': 'https://live.staticflickr.com/65535/50511756187_682394e7a8_b.jpg'
      },
      {
        'id': 71,
        'date': '2020/05/14',
        'name': 'Pensamiento Lógico',
        'url': 'https://live.staticflickr.com/65535/50510881673_79a7ce0d47_b.jpg'
      },
      {
        'id': 72,
        'date': '2019/09/17',
        'name': 'Photoshop',
        'url': 'https://live.staticflickr.com/65535/50510881653_d4b33c2f69_b.jpg'
      },
      {
        'id': 73,
        'date': '2018/12/30',
        'name': 'PostCSS',
        'url': 'https://live.staticflickr.com/65535/50511756147_240e4cbd21_b.jpg'
      },
      {
        'id': 74,
        'date': '2020/06/19',
        'name': 'Preprocesadores CSS',
        'url': 'https://live.staticflickr.com/65535/50511596161_fef0c83f8b_b.jpg'
      },
      {
        'id': 75,
        'date': '2020/06/04',
        'name': 'PreWork Buenas Prácticas y Entorno de desarrollo',
        'url': 'https://live.staticflickr.com/65535/50511596146_82ec73ac0e_b.jpg'
      },
      {
        'id': 76,
        'date': '2020/06/01',
        'name': 'Profesional de Arquitectura de Software',
        'url': 'https://live.staticflickr.com/65535/50511596126_4731d5dfc1_b.jpg'
      },
      {
        'id': 77,
        'date': '2019/04/28',
        'name': 'Profesional Devops',
        'url': 'https://live.staticflickr.com/65535/50511596101_5d516f20f4_b.jpg'
      },
      {
        'id': 78,
        'date': '2019/10/29',
        'name': 'Profesional de JavaScript',
        'url': 'https://live.staticflickr.com/65535/50511596081_12146a8448_b.jpg'
      },
      {
        'id': 79,
        'date': '2018/12/01',
        'name': 'Profesional de Git y GitHub',
        'url': 'https://live.staticflickr.com/65535/50511756007_7417acf662_b.jpg'
      },
      {
        'id': 80,
        'date': '2019/09/21',
        'name': 'Profesional de Git y GitHub',
        'url': 'https://live.staticflickr.com/65535/50511596041_0343cc795c_b.jpg'
      },
      {
        'id': 81,
        'date': '2018/11/12',
        'name': 'Programación Básica',
        'url': 'https://live.staticflickr.com/65535/50510881533_7ae7a846d0_b.jpg'
      },
      {
        'id': 82,
        'date': '2020/05/22',
        'name': 'Programación en Bash Shell',
        'url': 'https://live.staticflickr.com/65535/50510881508_b18d80880e_b.jpg'
      },
      {
        'id': 83,
        'date': '2020/05/23',
        'name': 'Programación Orientada a Objetos',
        'url': 'https://live.staticflickr.com/65535/50510881473_0dbd16eff7_b.jpg'
      },
      {
        'id': 84,
        'date': '2020/07/28',
        'name': 'Progressive Web Apps con React Js',
        'url': 'https://live.staticflickr.com/65535/50511755952_6b120a5d7a_b.jpg'
      },
      {
        'id': 85,
        'date': '2020/04/04',
        'name': 'Python',
        'url': 'https://live.staticflickr.com/65535/50511595931_82665161db_b.jpg'
      },
      {
        'id': 86,
        'date': '2020/09/19',
        'name': 'React Avanzado',
        'url': 'https://live.staticflickr.com/65535/50511755887_13e3438580_b.jpg'
      }
    ]
  },
  {
    'id': 4,
    'type': 'Marketing',
    'description': [
      {
        'id': 1,
        'date': '2020/04/03',
        'name': 'Community Manager',
        'url': 'https://live.staticflickr.com/65535/50511942921_4202409f5c_b.jpg'
      },
      {
        'id': 2,
        'date': '2019/10/10',
        'name': 'Email Marketing',
        'url': 'https://live.staticflickr.com/65535/50512103992_6b231927a1_b.jpg'
      },
      {
        'id': 3,
        'date': '2019/09/21',
        'name': 'Estrategia y Creación de Contenido Digital',
        'url': 'https://live.staticflickr.com/65535/50511942881_ebe9b05a4e_b.jpg'
      },
      {
        'id': 4,
        'date': '2019/04/06',
        'name': 'Facebook ADS',
        'url': 'https://live.staticflickr.com/65535/50512103957_fc2d0168b4_b.jpg'
      },
      {
        'id': 5,
        'date': '2019/04/06',
        'name': 'Profesional de Facebook Analytics',
        'url': 'https://live.staticflickr.com/65535/50512103942_4f877374d6_b.jpg'
      },
      {
        'id': 6,
        'date': '2020/05/10',
        'name': 'Fundamentos de Instagram',
        'url': 'https://live.staticflickr.com/65535/50512103922_e27cacef99_b.jpg'
      },
      {
        'id': 7,
        'date': '2020/05/9',
        'name': 'Fundamentos de Instagram',
        'url': 'https://live.staticflickr.com/65535/50511942801_d3464ddba1_b.jpg'
      },
      {
        'id': 8,
        'date': '2019/04/10',
        'name': 'Profesional de Google ADS',
        'url': 'https://live.staticflickr.com/65535/50512103887_b589a06349_b.jpg'
      },
      {
        'id': 9,
        'date': '2019/04/01',
        'name': 'Google Suite',
        'url': 'https://live.staticflickr.com/65535/50511942751_d20fbf7ab3_b.jpg'
      },
      {
        'id': 10,
        'date': '2019/04/03',
        'name': 'Instagram ADS y Optimización de Campañas',
        'url': 'https://live.staticflickr.com/65535/50511225413_7121ae9c61_b.jpg'
      },
      {
        'id': 11,
        'date': '2019/03/28',
        'name': 'Marketing Digital',
        'url': 'https://live.staticflickr.com/65535/50511942691_903a92afb0_b.jpg'
      },
      {
        'id': 12,
        'date': '2019/03/29',
        'name': 'Marketing con Influencers',
        'url': 'https://live.staticflickr.com/65535/50511942671_d9baca1343_b.jpg'
      },
      {
        'id': 13,
        'date': '2019/03/28',
        'name': 'Marketing de Voz a Voz',
        'url': 'https://live.staticflickr.com/65535/50511225353_5bd0ee45e0_b.jpg'
      },
      {
        'id': 14,
        'date': '2019/04/04',
        'name': 'Marketing de Móvil',
        'url': 'https://live.staticflickr.com/65535/50512103787_af5193b5d0_b.jpg'
      },
      {
        'id': 15,
        'date': '2019/05/13',
        'name': 'Profesional de Google Analytics',
        'url': 'https://live.staticflickr.com/65535/50512103767_8a20a82410_b.jpg'
      },
      {
        'id': 16,
        'date': '2019/03/31',
        'name': 'Relaciones Públicas y Prensa',
        'url': 'https://live.staticflickr.com/65535/50511225288_dd35a74b22_b.jpg'
      }
    ]
  },
  {
    'id': 5,
    'type': 'Business and Entrepreneurship',
    'description': [
      {
        'id': 1,
        'date': '2018/10/30',
        'name': 'Como Financiar tu Plan de Empresa',
        'url': 'https://live.staticflickr.com/65535/50481798193_8fe2a6c3bc_h.jpg'
      },
      {
        'id': 2,
        'date': '2018/11/09',
        'name': 'Como Financiar tu Plan de Negocios',
        'url': 'https://live.staticflickr.com/65535/50482660202_b45035b5ac_h.jpg'
      },
      {
        'id': 3,
        'date': '2018/11/02',
        'name': 'Legislación Laboral, Formas de Contratar y Seguridad Social',
        'url': 'https://live.staticflickr.com/65535/50481798148_2822573a31_h.jpg'
      },
      {
        'id': 4,
        'date': '2018/10/26',
        'name': 'Conozca el Proceso de Importación en Colombia',
        'url': 'https://live.staticflickr.com/65535/50482660157_f118451d7b_h.jpg'
      },
      {
        'id': 5,
        'date': '2020/05/06',
        'name': 'Comunicación Online con Slack',
        'url': 'https://live.staticflickr.com/65535/50510859548_2bd96489e7_b.jpg'
      },
      {
        'id': 6,
        'date': '2020/05/13',
        'name': 'Gestión Efectiva del Tiempo',
        'url': 'https://live.staticflickr.com/65535/50511734822_cf77564d21_b.jpg'
      },
      {
        'id': 7,
        'date': '2020/04/04',
        'name': 'Trabajo Remoto o Teletrabajo',
        'url': 'https://live.staticflickr.com/65535/50511574031_19f0f49a03_b.jpg'
      }
    ]
  },
  {
    'id': 6,
    'type': 'Startups',
    'description': [
      {
        'id': 1,
        'date': '2018/11/04',
        'name': 'Financiamiento StartUps',
        'url': 'https://live.staticflickr.com/65535/50475230686_ed8ca68df3_h.jpg'
      },
      {
        'id': 2,
        'date': '2018/11/03',
        'name': 'Financiamiento StartUps',
        'url': 'https://live.staticflickr.com/65535/50511567061_9d2b402fcc_b.jpg'
      }
    ]
  },
  {
    'id': 7,
    'type': 'Professional Growth',
    'description': [
      {
        'id': 1,
        'date': '2020/10/01',
        'name': 'Crear un Perfil de Éxito en LinkedIn',
        'url': 'https://live.staticflickr.com/65535/50510603973_1075d8c1c6_h.jpg'
      },
      {
        'id': 2,
        'date': '2020/09/25',
        'name': 'Cómo Conseguir Trabajo en Programación',
        'url': 'https://live.staticflickr.com/65535/50511275258_c6d939f0d5_b.jpg'
      },
      {
        'id': 3,
        'date': '2018/12/12',
        'name': 'Marca Personal',
        'url': 'https://live.staticflickr.com/65535/50512154102_8fd4f2182b_b.jpg'
      }
    ]
  },
  {
    'id': 8,
    'type': 'Sciences',
    'description': [
      {
        'id': 1,
        'date': '2019/09/17',
        'name': 'Astrobiología',
        'url': 'https://live.staticflickr.com/65535/50511280853_4962835758_b.jpg'
      }
    ]
  },
  {
    'id': 9,
    'type': 'Other',
    'description': [
      {
        'id': 1,
        'date': '2018/12/26',
        'name': 'Transacciones Seguras con Tarjeta Débito',
        'url': 'https://live.staticflickr.com/65535/50511308371_53b3ba91d9_k.jpg'
      },
      {
        'id': 2,
        'date': '2020/04/12',
        'name': 'Cómo Lavarse Correctamente las Manos',
        'url': 'https://live.staticflickr.com/65535/50511988391_1de6e7e0d3_b.jpg'
      }
    ]
  }
];